var _path, _path2, _g, _ellipse, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalisman({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 68 64",
    width: 68,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m50.1162 35.6631c.6081 1.3243 2.3987 1.792 3.4291.7616l1.8897-1.8897c1.9526-1.9526 5.1185-1.9526 7.0711 0s1.9526 5.1185 0 7.0711l-15.2721 15.272c-3.6687 4.355-9.1626 7.1219-15.3026 7.1219-6.403 0-12.1032-3.0089-15.7638-7.6898l-14.70309-14.7032c-1.952618-1.9526-1.952619-5.1184.00001-7.071 1.95262-1.9526 5.11844-1.9526 7.07106 0l1.86102 1.861c1.0079 1.0079 2.7577.5545 3.353-.7406.1176-.2559.1816-.5305.1816-.8121l-.0001-22.8444c0-2.76139 2.2386-4.99995 5-4.99995 2.7615-.00001 5 2.23857 5 4.99995v11.5565c0 .9944 1.0187 1.6694 1.9669 1.3698.6001-.1897 1.0336-.736 1.0336-1.3654v-18.56078c0-2.76143 2.2386-4.99999355 5-4.99999427 2.7614-.00000073 5 2.23857427 5 4.99998427v18.56119c0 .6292.4334 1.1754 1.0333 1.365.9479.2996 1.9663-.3752 1.9663-1.3693v-11.557c0-2.76139 2.2386-4.99995 5-4.99995s5 2.23857 5 4.99995v22.8351c0 .2872.0652.5671.185.8281z",
    fill: "#fd4848",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m47.9318 45.9999s-7.1634 10-16 10c-8.8365 0-16-10-16-10s7.1635-10 16-10c8.8366 0 16 10 16 10z",
    fill: "#d5ff5c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fd4848"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.4316 46.0001c0 4.1419-3.3576 7.4996-7.4996 7.4996-4.1419 0-7.4996-3.3577-7.4996-7.4996s3.3577-7.4996 7.4996-7.4996c4.142 0 7.4996 3.3577 7.4996 7.4996z",
    strokeWidth: 1.00078
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.4314 46.0004c0 2.485-2.0146 4.4996-4.4996 4.4996-2.4851 0-4.4996-2.0146-4.4996-4.4996 0-2.4851 2.0145-4.4997 4.4996-4.4997 2.485 0 4.4996 2.0146 4.4996 4.4997z",
    strokeWidth: 1.00078
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.4314 46.0001c.0001 5.7987-4.7008 10.4996-10.4996 10.4996-5.7987 0-10.4996-4.7008-10.4996-10.4996s4.7009-10.4996 10.4996-10.4996c5.7988 0 10.4996 4.7008 10.4996 10.4996z",
    strokeWidth: 1.00078
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.4314 46c0 7.4557-6.044 13.4996-13.4996 13.4996-7.4557 0-13.4996-6.0439-13.4996-13.4996 0-7.4556 6.0439-13.4996 13.4996-13.4996 7.4556 0 13.4996 6.044 13.4996 13.4996z",
    strokeWidth: 1.00078
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.4317 45.9999c0 .8282-.6714 1.4996-1.4996 1.4996-.8283 0-1.4997-.6714-1.4997-1.4996s.6714-1.4996 1.4997-1.4996c.8282 0 1.4996.6714 1.4996 1.4996z",
    fill: "#162beb",
    strokeWidth: 1.00078
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9321,
    cy: 45.9999,
    fill: "#fd4848",
    rx: 2,
    ry: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.6516 46.122c-.0342-.0439-.0657-.0846-.0945-.1221.0288-.0374.0603-.0781.0945-.122.2085-.2676.5176-.6517.9163-1.1134.7981-.9241 1.9525-2.1556 3.3772-3.3858 2.8651-2.4738 6.7497-4.8784 10.9867-4.8784 4.2371 0 8.1216 2.4046 10.9867 4.8784 1.4248 1.2302 2.5792 2.4617 3.3773 3.3858.3987.4617.7077.8458.9163 1.1134.0342.0439.0657.0846.0945.122-.0288.0375-.0603.0782-.0945.1221-.2086.2676-.5176.6517-.9163 1.1134-.7981.9241-1.9525 2.1556-3.3773 3.3858-2.8651 2.4738-6.7496 4.8783-10.9867 4.8783-4.237 0-8.1216-2.4045-10.9867-4.8783-1.4247-1.2302-2.5791-2.4617-3.3772-3.3858-.3987-.4617-.7078-.8458-.9163-1.1134z",
    stroke: "#d5ff5c",
    strokeWidth: 1.00078
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalisman);
export default __webpack_public_path__ + "static/media/talisman.e61aef36.svg";
export { ForwardRef as ReactComponent };